import React from 'react'
import { FiBox, FiPackage, FiAlertCircle, FiDroplet } from "react-icons/fi";

const data = [
  {
    category: "Electronic Items",
    items: ["Mobile Phones & Accessories", "Tablets", "Laptops, Personal computers and their accessories"],
  },
  {
    category: "Electrical Items",
    items: ["Small home appliances", "Power equipments", "Industrial equipments"],
  },
  {
    category: "Fragile Items",
    items: ["Glassware", "Crockery", "Home Decor"],
  },
  {
    category: "Apparels",
    items: ["Flexible Packaging", "Rigid Packaging"],
  },
  {
    category: "Fashion Accessories",
    items: ["Jewellery", "Watches"],
  },
  {
    category: "Liquid Items",
    items: ["Beauty & Personal Care", "Food products, Medicines", "Automotive"],
  },
  {
    category: "Others",
    items: ["Books & Stationeries", "Travel Gears"],
  },
];
const datatabel = [
  {
    title: "The Box",
    points: [
      "The box is sturdy with no damage",
      "The box is not bulging out",
      "No rattling sound of item when shaken",
      "No wetness on the box",
    ],
  },
  {
    title: "Packing",
    points: [
      "Correct the box size if bulging out",
      "Provide sufficient void fills to avoid movement of item",
    ],
  },
  {
    title: "Labelling",
    points: [
      "The label is not over any seams",
      "The label is not over any edges",
      "The barcodes are readable and are on the flat single surface",
      "Essential data is visible on the shipment label",
      "Special handling labels are visible",
    ],
  },
  {
    title: "Sealing",
    points: [
      "The tape joins the seams intact",
      "No gaps at the seams",
      "H-taping is done for secondary packages",
    ],
  },
];

const Accodion = () => {
  return (
    <>
      <div className="mx-auto max-w-auto px-6 space-y-12 lg:px-8">
        <div>
          <p className="text-gray-600 text-base lg:text-lg">
            At AlgarXpress, we understand the importance of proper packaging in
            ensuring the safe delivery of your shipments. That's why we provide
            comprehensive packaging guidelines that cover various aspects such as
            measuring and weighing packages, packaging methods, sealing and
            labeling instructions, as well as guidelines for handling restricted
            items.
          </p>
          {/* Takeaway Section */}
          <div className="mt-6">
            <h2 className="text-sm lg:text-2xl font-medium text-gray-800 mb-4">
              Expected Takeaways
            </h2>
            <ul className="list-decimal pl-6 text-gray-700 space-y-2">
              <li>An overview of the packaging process</li>
              <li>The different categories of products</li>
              <li>The packaging process of different categories</li>
              <li>The Final Checklist</li>
            </ul>
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            1. Understanding the item for appropriate packing choices
          </h1>
          <p className="text-gray-600 text-base lg:text-lg mb-6">
            An understanding about the product/item to be shipped makes it easy
            to choose an efficient and cost-effective packaging. The following
            table relates the basic characteristics of the item to the parameters
            for the selection of packages:
          </p>
          <h2 className="text-lg lg:text-xl font-medium text-gray-800 mb-4">
            The relationship: Item & package choice
          </h2>
          {/* Table Section */}
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border border-gray-300 text-left">
              <thead>
                <tr className="bg-slate-200 text-gray-800">
                  <th className="px-4 py-3 border border-gray-300">
                    Item Characteristics
                  </th>
                  <th className="px-4 py-3 border border-gray-300">
                    Importance for Packaging
                  </th>
                  <th className="px-4 py-3 border border-gray-300">
                    Representation
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Dimension of item */}
                <tr>
                  <td className="px-4 py-3 border border-gray-300">
                    Dimension of item
                  </td>
                  <td className="px-4 py-3 border border-gray-300">
                    <ul className="list-disc pl-5 space-y-2">
                      <li>Helps in selection of appropriate size of boxes/flyers</li>
                      <li>Minimize inventory & cost</li>
                    </ul>
                  </td>
                  <td className="px-4 py-3 border border-gray-300 text-center">
                    <FiBox className="w-8 h-8 mx-auto text-blue-500" />
                  </td>
                </tr>
                {/* Weight of the item */}
                <tr className="bg-slate-100">
                  <td className="px-4 py-3 border border-gray-300">
                    Weight of the item
                  </td>
                  <td className="px-4 py-3 border border-gray-300">
                    <ul className="list-disc pl-5 space-y-2">
                      <li>
                        Optimize for the maximum strength required for the box
                      </li>
                      <li>Ensure safety of the item</li>
                    </ul>
                  </td>
                  <td className="px-4 py-3 border border-gray-300 text-center">
                    <FiPackage className="w-8 h-8 mx-auto text-green-500" />
                  </td>
                </tr>
                {/* Fragility of item */}
                <tr>
                  <td className="px-4 py-3 border border-gray-300">
                    Fragility of item
                  </td>
                  <td className="px-4 py-3 border border-gray-300">
                    <ul className="list-disc pl-5 space-y-2">
                      <li>Helps in selection of appropriate box strength</li>
                      <li>Helps in optimizing the cushioning items</li>
                    </ul>
                  </td>
                  <td className="px-4 py-3 border border-gray-300 text-center">
                    <FiAlertCircle className="w-8 h-8 mx-auto text-red-500" />
                  </td>
                </tr>
                {/* Physical state */}
                <tr className="bg-slate-100">
                  <td className="px-4 py-3 border border-gray-300">
                    Physical state
                  </td>
                  <td className="px-4 py-3 border border-gray-300">
                    <ul className="list-disc pl-5 space-y-2">
                      <li>
                        Identifies the need for any special requirements of the
                        protection of item
                      </li>
                      <li>
                        E.g. Liquid products need additional leak-proofing
                      </li>
                    </ul>
                  </td>
                  <td className="px-4 py-3 border border-gray-300 text-center">
                    <FiDroplet className="w-8 h-8 mx-auto text-blue-500" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">2. Selection of Boxes</h2>
          <p className="text-gray-700 mb-4">
            The right selection of boxes is crucial for the safe delivery of any item shipped.
          </p>
          <h3 className="text-lg font-semibold text-gray-900 mb-3">Box Selection</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border border-gray-300 text-left">
              <thead>
                <tr className="bg-slate-200 text-gray-800">
                  <th className="px-4 py-3 border border-gray-300">Criteria</th>
                  <th className="px-4 py-3 border border-gray-300">Details</th>
                </tr>
              </thead>
              <tbody>
                {/* Material */}
                <tr>
                  <td className="px-4 py-3 border border-gray-300 font-medium">
                    Material
                  </td>
                  <td className="px-4 py-3 border border-gray-300">
                    <ul className="list-disc pl-5 space-y-1">
                      <li>Use corrugated boxes of 3 ply for products below 4 Kgs or not fragile.</li>
                      <li>Use corrugated boxes of 5 ply for products above 4 Kgs and fragile.</li>
                      <li>Use tamper-evident box/flyer for high-value items (Cost above 7000).</li>
                      <li>Ensure the material can withstand the required edge crush & burst factor load.</li>
                    </ul>
                  </td>
                </tr>
                {/* Size */}
                <tr className="bg-slate-100">
                  <td className="px-4 py-3 border border-gray-300 font-medium">
                    Size
                  </td>
                  <td className="px-4 py-3 border border-gray-300">
                    <ul className="list-disc pl-5 space-y-1">
                      <li>Optimize the size of the boxes as per the product dimensions.</li>
                      <li>The box should not be too small or too big for the item shipped. An optimum size box should be chosen.</li>
                    </ul>
                  </td>
                </tr>
                {/* Quick Check */}
                <tr>
                  <td className="px-4 py-3 border border-gray-300 font-medium">
                    Quick Check
                  </td>
                  <td className="px-4 py-3 border border-gray-300">
                    <ul className="list-disc pl-5 space-y-1">
                      <li>Inspect the box for holes, tears, crushed items, and sturdiness.</li>
                      <li>Avoid poor quality boxes for the safety of items.</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <div className="grid grid-cols-1 items-center sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Heat Shrink Sleeves */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap16.png"
                alt="Heat Shrink Sleeves"
                className="mb-4"
              />
            </div>

            {/* Taping of Bottle Caps */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap17.png"
                alt="Taping Of Bottle Caps"
                className="mb-4"
              />
            </div>

            {/* Zip Lock or Leak Proof Pouches */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap18.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="mb-4"
              />
            </div>
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap19.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="mb-4"
              />
            </div>
          </div>
          <p className='font-semibold text-lg text-center'>Choose appropriate size of the box by considering the dimension of the item to be shipped
          </p>
        </div>

        <div>
          <h3 className="text-2xl font-bold text-gray-800 mb-6">
            3. Selection of Flyer & Boxes
          </h3>
          <p className="text-gray-700 text-sm md:text-base mb-8">
            Flyers are quick & handy in packing of flexible items such as apparels
            or can be used as an added protection for the safety of the shipment
            from external fluids, tampering etc.
          </p>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-slate-100">
                  <th className="border border-gray-300 p-3 text-left font-medium text-gray-700">
                    Flyer Selection
                  </th>
                  <th className="border border-gray-300 p-3 text-left font-medium text-gray-700">
                    Details
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-3 text-gray-600">
                    <span className="font-medium">Material</span>
                  </td>
                  <td className="border border-gray-300 p-3 text-gray-600">
                    <ul className="list-disc pl-5">
                      <li>Choose 60-80 microns hot melt glue adhesive LDPE polybag</li>
                      <li>
                        Use tamper evident poly bags for high value items (Cost
                        above 5000)
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-3 text-gray-600">
                    <span className="font-medium">Quick Check</span>
                  </td>
                  <td className="border border-gray-300 p-3 text-gray-600">
                    <ul className="list-disc pl-5">
                      <li>Inspect the polybag for any damages</li>
                      <li>
                        Ensure the opening is sealed properly after picking the item
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-bold text-gray-800 mb-6">
            4. Packaging of an Item
          </h3>
          <p className="text-gray-700 text-sm md:text-base mb-6">
            Packaging of an item involves leak-proofing, cushioning, placing of the
            item & filling of the voids in the box. Enough cushioning needs to be
            provided to ensure no loads are transferred to the items.
          </p>
          <h4 className="text-xl font-semibold text-gray-800 mb-4">Cushioning</h4>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 mb-8">
              <thead>
                <tr className="bg-slate-100">
                  <th className="border border-gray-300 p-3 text-left font-medium text-gray-700">
                    Material
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-3 text-gray-600">
                    <ul className="list-disc pl-5">
                      <li>Bubble wrap</li>
                      <li>Foam sheets</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="flex flex-wrap md:space-x-20 justify-center gap-6">
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap2.png" // Replace with the actual image URL
                alt="Bubble Wrap"
                className="w-56 h-56 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium me-6">Bubble Wrap</p>
            </div>
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap3.png" // Replace with the actual image URL
                alt="Foam Sheets"
                className="w-56 h-56 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium me-2">Foam Sheets</p>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-bold text-gray-800 mb-6">
            REFERENCE TABLE: Internal Packaging Material vs. Functionality
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-300 text-left">
              <thead>
                <tr className="bg-slate-100">
                  <th className="border border-gray-300 p-3 font-medium text-gray-700">
                    Material
                  </th>
                  <th className="border border-gray-300 p-3 font-medium text-gray-700">
                    Cushioning
                  </th>
                  <th className="border border-gray-300 p-3 font-medium text-gray-700">
                    Void Fill
                  </th>
                  <th className="border border-gray-300 p-3 font-medium text-gray-700">
                    Surface Protection
                  </th>
                  <th className="border border-gray-300 p-3 font-medium text-gray-700">
                    Divider
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    material: "Bubble Wrap",
                    cushioning: "Yes",
                    voidFill: "Yes",
                    surfaceProtection: "Yes",
                    divider: "",
                  },
                  {
                    material: "Foam Sheets",
                    cushioning: "Yes",
                    voidFill: "Yes",
                    surfaceProtection: "Yes",
                    divider: "",
                  },
                  {
                    material: "Airbags",
                    cushioning: "Yes",
                    voidFill: "",
                    surfaceProtection: "",
                    divider: "",
                  },
                  {
                    material: "Shredded Paper",
                    cushioning: "Yes",
                    voidFill: "",
                    surfaceProtection: "",
                    divider: "",
                  },
                  {
                    material: "Crumpled Paper",
                    cushioning: "Yes",
                    voidFill: "",
                    surfaceProtection: "",
                    divider: "",
                  },
                  {
                    material: "Corrugated Inserts",
                    cushioning: "",
                    voidFill: "",
                    surfaceProtection: "",
                    divider: "Yes",
                  },
                ].map((row, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "bg-slate-50" : "bg-white"}
                  >
                    <td className="border border-gray-300 p-3">{row.material}</td>
                    <td className="border border-gray-300 p-3">{row.cushioning}</td>
                    <td className="border border-gray-300 p-3">{row.voidFill}</td>
                    <td className="border border-gray-300 p-3">
                      {row.surfaceProtection}
                    </td>
                    <td className="border border-gray-300 p-3">{row.divider}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold mb-4">5. Packaging of an Item</h1>
          <p className="text-gray-700 mb-6">
            Liquid items need to be made leak proof before cushioning or packing.
            Common leak-proofing techniques are mentioned below.
          </p>

          <h2 className="text-xl font-semibold mb-2">Leak Proofing</h2>
          <table className="w-full border-collapse border border-gray-300 text-left mb-6">
            <thead>
              <tr>
                <th className="border border-gray-300 p-2">Material</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2">
                  <ul className="list-disc list-inside">
                    <li>Heat shrink sleeves</li>
                    <li>Taping of bottle caps</li>
                    <li>Zip lock or leak-proof pouches</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Heat Shrink Sleeves */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap4.png"
                alt="Heat Shrink Sleeves"
                className="w-56 h-56 mb-4"
              />
              <p className="font-semibold">Heat Shrink Sleeves</p>
            </div>

            {/* Taping of Bottle Caps */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap6.png"
                alt="Taping Of Bottle Caps"
                className="w-56 h-56 mb-4"
              />
              <p className="font-semibold">Taping Of Bottle Caps</p>
            </div>

            {/* Zip Lock or Leak Proof Pouches */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap7.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="w-56 h-56 object-cover mb-4"
              />
              <p className="font-semibold">Zip Lock or Leak Proof Pouches</p>
            </div>
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold mb-4">6. Packing of the item</h1>
          <p className="text-gray-700 mb-6">
            All the voids in the box needs to be filled to restrict the movement of the items in the box. Void fill materials as listed below
            can be used for the purpose.
          </p>

          <h2 className="text-xl font-semibold mb-2">Void Fill
          </h2>
          <table className="w-full border-collapse border border-gray-300 text-left mb-6">
            <thead>
              <tr>
                <th className="border border-gray-300 p-2">Material</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2">
                  <ul className="list-disc list-inside">
                    <li>Air cushions/Air pouches</li>
                    <li>Crumpled paper </li>
                    <li>Cardboard inserts (also used as divider for multiple products)
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Heat Shrink Sleeves */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap8.png"
                alt="Heat Shrink Sleeves"
                className="w-60 h-60 mb-4"
              />
              <p className="font-semibold">Air cushions/Air pouches</p>
            </div>

            {/* Taping of Bottle Caps */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap9.png"
                alt="Taping Of Bottle Caps"
                className="w-60 h-60 mb-4"
              />
              <p className="font-semibold me-4">Crumpled paper </p>
            </div>

            {/* Zip Lock or Leak Proof Pouches */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap10.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="w-60 h-60 object-cover mb-4"
              />
              <p className="font-semibold ms-2">Cardboard inserts</p>
            </div>
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold mb-4">7. Sealing of the consignment</h1>
          <p className="text-gray-700 mb-6">
            Sealing ensures that the properly packed item is secured and intact inside the box throughout the journey of the shipment.

          </p>

          <h2 className="text-xl font-semibold mb-2">Sealing
          </h2>
          <table className="w-full border-collapse border border-gray-300 text-left mb-6">
            <thead>
              <tr>
                <th className="border border-gray-300 p-2">Tape</th>
              </tr>
              <tr>
                <th className="border border-gray-300 p-2">Locations</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2">
                  <ul className="list-disc list-inside">
                    <li>Use branded pressure sensitive tapes such as BOPP</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <ul className="list-disc list-inside">
                    <li>Seal the center seam of the top and the bottom of the box</li>
                    <li>For heavy,liquid & fragile items, apply H-taping by sealing both the center and edge seams on the box</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="flex flex-wrap lg:space-x-20 justify-center gap-6">
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap11.png" // Replace with the actual image URL
                alt="Bubble Wrap"
                className=" h-56 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium ms-2">Taping for light weight shipments</p>
            </div>
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap12.png" // Replace with the actual image URL
                alt="Foam Sheets"
                className=" h-56 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium ms-2">H-Taping for heavy, liquid and fragile shipments</p>
            </div>
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold mb-4">8. Labelling of the Shipment</h1>
          <p className="text-gray-700 mb-6">
            Proper labelling is crucial for faster & safe handling of the shipment
            in reaching the intended destination.
          </p>

          {/* Essential Data Table */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h2 className="text-xl font-semibold mb-2">Shipment Label</h2>
              <table className="w-full border-collapse border border-gray-300 text-left mb-6">
                <thead>
                  <tr>
                    <th className="border border-gray-300 p-2">Essential Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 p-2">
                      <ul className="list-disc list-inside">
                        <li>Barcode</li>
                        <li>
                          Waybill number and barcode (Incase of shipments of order
                          value above 50,000)
                        </li>
                        <li>Shipment number & barcode</li>
                        <li>Consignee address</li>
                        <li>Return address</li>
                        <li>Retail / Tax Invoice</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Shipment Label Example */}
            <div className="flex justify-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/labels.jpeg"
                alt="Shipment Label Example"
                className="rounded-lg h-96 shadow-lg border border-gray-200"
              />
            </div>
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold mb-4">9. Labelling of the shipment</h1>
          <p className="text-gray-700 mb-6">
            The label should be pasted at the right location to make it compatible with the requirements of logistics system for a fast &
            efficient delivery

          </p>

          {/* Essential Data Table */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h2 className="text-xl font-semibold mb-2">Location of Label
              </h2>
              <table className="w-full border-collapse border border-gray-300 text-left mb-6">
                <thead>
                  <tr>
                    <th className="border border-gray-300 p-2">Essential
                      Data
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 p-2">
                      <ul className="list-disc list-inside">
                        <li>Barcode</li>
                        <li>
                          Paste the label on the seamless flat face of
                          the box/flyer

                        </li>
                        <li>Paste the label away from the seams or
                          edges of the box
                        </li>
                        <li> Readability of barcode is important for faster
                          and correct processing of shipments</li>
                        <li>In flyers/polybags all the essential data on
                          labels should be visible and the label should
                          be placed flat</li>
                        <li>The pocket containing the label in the flyer
                          should be taped at the opening to avoid the
                          loss of label </li>
                        <li>Thermal printed labels are strongly
                          recommended over regular labels</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Shipment Label Example */}
            <div className="flex justify-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap14.png"
                alt="Shipment Label Example"
                className="h-96"
              />
            </div>
          </div>
        </div>

        <div>
          <div className="grid grid-cols-1 items-center sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Heat Shrink Sleeves */}
            <div>
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap20.png"
                alt="Heat Shrink Sleeves"
                className="mb-4"
              />
            </div>

            {/* Taping of Bottle Caps */}
            <div>
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap21.png"
                alt="Taping Of Bottle Caps"
                className="mb-4"
              />
            </div>

            {/* Zip Lock or Leak Proof Pouches */}
            <div>
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap22.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="mb-4"
              />
            </div>
            <div>
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap23.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="mb-4"
              />
            </div>
            <div>
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap24.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="mb-4 saturate-50"
              />
            </div>
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold mb-4">10. Special handling label</h1>
          <p className="text-gray-700 mb-6">
            Special handling labels helps in communicating the necessary information for appropriately handling the shipment.
          </p>

          {/* Essential Data Table */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h2 className="text-xl font-semibold mb-2">Special Handling Labels
              </h2>
              <table className="w-full border-collapse border border-gray-300 text-left mb-6">
                <thead>
                  <tr>
                    <th className="border border-gray-300 p-2">Common
                      Categories
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 p-2">
                      <ul className="list-disc list-inside">
                        <li>Fragile</li>
                        <li>Perishables
                        </li>
                        <li>Dangerous Goods

                        </li>
                        <li>Package orientation</li>
                        <li>Keep Dry</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Shipment Label Example */}
            <div className="flex justify-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/s88.png"
                alt="Shipment Label Example"
                className="h-96"
              />
            </div>
          </div>
        </div>

        <div>
          <p className='text-3xl font-bold'>The categories and Items</p>
          <h1 className="text-xl font-bold mb-3 mt-6">Categories and Items</h1>
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-300">
              <thead>
                <tr className="bg-slate-100">
                  <th className="text-left p-3 border-b border-gray-300 text-gray-700">Categories</th>
                  <th className="text-left p-3 border-b border-gray-300 text-gray-700">Different Items</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => (
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? "bg-white" : "bg-slate-50"}`}
                  >
                    <td className="p-3 border-b border-gray-300 text-gray-800 font-medium">
                      {row.category}
                    </td>
                    <td className="p-3 border-b border-gray-300 text-gray-800">
                      <ul className="list-disc pl-5">
                        {row.items.map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div>
            <p className='text-2xl font-bold mt-12'>Packaging Process For
              Electronics Items</p>
            <h1 className="text-xl font-bold mb-3 mt-6">1. Packaging Process: Preparing the item
            </h1>
            <div className="flex flex-wrap lg:space-x-20 justify-center gap-6">
              <div className="text-center">
                <img
                  src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap26.png" // Replace with the actual image URL
                  alt="Bubble Wrap"
                  className=" h-64 object-cover mx-auto mb-3"
                />
                <p className="text-gray-700 font-medium">Check the product
                  seal and Shipment
                </p>
              </div>
              <div className="text-center">
                <img
                  src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap27.png" // Replace with the actual image URL
                  alt="Foam Sheets"
                  className=" h-64 object-cover mx-auto mb-3"
                />
                <p className="text-gray-700 font-medium">Wrap the product in
                  the bubble wrap</p>
              </div>
            </div>

            <h1 className="text-xl font-bold mb-3 mt-12">2. Packaging Process: Packaging the item in the box
            </h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Heat Shrink Sleeves */}
              <div className="flex flex-col items-center text-center">
                <img
                  src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap28.png"
                  alt="Heat Shrink Sleeves"
                  className="mb-4 saturate-50"
                />
              </div>

              {/* Taping of Bottle Caps */}
              <div className="flex flex-col items-center text-center">
                <img
                  src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap29.png"
                  alt="Taping Of Bottle Caps"
                  className="mb-4 saturate-50"
                />
              </div>

              {/* Zip Lock or Leak Proof Pouches */}
              <div className="flex flex-col items-center text-center">
                <img
                  src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap30.png"
                  alt="Zip Lock or Leak Proof Pouches"
                  className="mb-4 saturate-50"
                />
              </div>
              <div className="flex flex-col items-center text-center">
                <img
                  src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap31.png"
                  alt="Zip Lock or Leak Proof Pouches"
                  className="mb-4 saturate-50"
                />
              </div>
            </div>

          </div>
        </div>

        <div>
          <p className='text-2xl font-bold mt-12'>Packaging Process For
            Electrical Items</p>
          <h1 className="text-xl font-bold mb-3 mt-6">1. Packaging Process: Preparing the item
          </h1>
          <div className="flex flex-wrap lg:space-x-20 justify-center gap-6">
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap33.png" // Replace with the actual image URL
                alt="Bubble Wrap"
                className=" h-64 saturate-50 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium">Check the product
                seal and order
              </p>
            </div>
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap34.png" // Replace with the actual image URL
                alt="Foam Sheets"
                className=" h-64 saturate-50 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium">Wrap the product in
                the bubble wrap</p>
            </div>
          </div>

          <h1 className="text-xl font-bold mb-3 mt-12">2. Packaging Process: Packaging the item in the box
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Heat Shrink Sleeves */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap35.png"
                alt="Heat Shrink Sleeves"
                className="h-60 saturate-50 mb-4"
              />
            </div>

            {/* Taping of Bottle Caps */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap36.png"
                alt="Taping Of Bottle Caps"
                className="h-60 saturate-50 mb-4"
              />
            </div>

            {/* Zip Lock or Leak Proof Pouches */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap37.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="h-60 saturate-50 mb-4"
              />
            </div>
          </div>

        </div>

        <div>
          <p className='text-2xl font-bold mt-12'>Packaging Process For
            Fragile Items</p>
          <h1 className="text-xl font-bold mb-3 mt-6">1. Packaging Process: Preparing the item
          </h1>
          <div className="flex flex-wrap lg:space-x-20 justify-center gap-6">
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap38.png" // Replace with the actual image URL
                alt="Bubble Wrap"
                className=" h-64 object-cover mx-auto mb-3"
              />
            </div>
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap39.png" // Replace with the actual image URL
                alt="Foam Sheets"
                className=" h-64 object-cover mx-auto mb-3"
              />
            </div>
            <p className='text-xl font-semibold text-center'>Wrap the fragile item in 3-4 layers of bubble wrap or foam sheet. It prevents stretches and provides cushioning
              to the product.</p>
          </div>

          <h1 className="text-xl font-bold mb-3 mt-12">2. Packaging Process: Packaging the item in the box
          </h1>
          <div className="grid grid-cols-1 items-center sm:grid-cols-2 lg:grid-cols-2 gap-6">
            {/* Heat Shrink Sleeves */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap40.png"
                alt="Heat Shrink Sleeves"
                className="h-60 mb-4"
              />
            </div>

            <div className="flex space-y-7 flex-col">
              <p>i) Layer the bottom of the box
                with void fill material</p>
              <p>ii) Place the item in the
                corrugated box
                maintaining the gap of
                30-50mm from the wall
                of the box
              </p>
              <p>iii) Fill the box completely and seal the box with
                BOPP tape</p>
            </div>
          </div>

        </div>

        <div>
          <p className='text-2xl font-bold mt-12'>Packaging Process For
            Apparels</p>
          <h1 className="text-xl font-bold mb-3 mt-6">1. Packaging Process: Preparing the item
          </h1>
          <div className="flex flex-wrap xl:space-x-20 justify-center gap-6">
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap41.png" // Replace with the actual image URL
                alt="Bubble Wrap"
                className=" h-64 object-cover mx-auto mb-3"
              />
              <p className='text-sm font-semibold text-center'>Case 1: Flexible primary packaging</p>
              <p className='text-sm text-center'>Ensure the apparel without any
                additional box packaging is packed
                in a branded polybag
              </p>
            </div>
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap42.png" // Replace with the actual image URL
                alt="Foam Sheets"
                className=" h-64 object-cover mx-auto mb-3"
              />
              <p className='text-sm font-semibold text-center'>Case 2: Rigid/box type primary packaging</p>
              <p className='text-sm text-center'>Check the condition of the box
                in which the apparel is packed</p>
            </div>

          </div>

          <h2 className="text-xl font-bold mt-12 mb-6 text-gray-800">
            2. Packaging Process: Packaging the Item in the Box
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {/* Case 1 */}
            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-4">
                Case 1: Final Packaging of the Flexible Product
              </h3>
              <div className="flex flex-col items-center justify-center gap-6 mb-4">
                <div className=" flex items-center justify-center">
                  <img src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap43.png" alt="" />
                </div>
                <div className="w-60 h-60 flex items-center justify-center">
                  <img src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap44.png" alt="" />
                </div>
              </div>
              <p className="text-gray-600 text-center mb-2">
                Place the packed apparel in a branded LDPE polybag
              </p>
              <p className="text-gray-600 text-center">
                Seal the LDPE polybag
              </p>
            </div>

            {/* Case 2 */}
            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-4">
                Case 2: Final Packaging of the Rigid/Box Type Product
              </h3>
              <div className="flex flex-col items-center justify-center gap-6 mb-4">
                <div className="w-60 h-60 flex items-center justify-center">
                  <img src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap46.png" alt="" />
                </div>
                <div className="w-60 h-60 flex items-center justify-center">
                  <img src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap47.png" alt="" />
                </div>
              </div>
              <p className="text-gray-600 text-center mb-2">
                Place the box in a corrugated box
              </p>
              <p className="text-gray-600 text-center me-2">
                Seal the seams using BOPP tape
              </p>
            </div>
          </div>

        </div>

        <div>
          <p className='text-2xl font-bold mt-12'>Packaging Process For
            Fashion Accessories</p>
          <h1 className="text-xl font-bold mb-3 mt-6">1. Packaging Process: Preparing the item
          </h1>
          <div className="flex flex-wrap lg:space-x-20 justify-center gap-6">
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap48.png" // Replace with the actual image URL
                alt="Bubble Wrap"
                className=" h-64 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium">Check the product packaging
                condition
              </p>
            </div>
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap49.png" // Replace with the actual image URL
                alt="Foam Sheets"
                className=" h-64 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium">Wrap the product box in the
                bubble wrap</p>
            </div>
          </div>

          <h1 className="text-xl font-bold mb-3 mt-12">2. Packaging Process: Packaging the item in the box
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Heat Shrink Sleeves */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap61.png"
                alt="Heat Shrink Sleeves"
                className="mb-4 saturate-50"
              />
              <p className="text-gray-700 font-medium">i) Choose a sturdy 3-ply
                corrugated box</p>
            </div>

            {/* Taping of Bottle Caps */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap62.png"
                alt="Taping Of Bottle Caps"
                className="mb-4 saturate-50"
              />
              <p className="text-gray-700 font-medium">ii) Place the item in the
                corrugated box ensuring
                all voids are filled</p>
            </div>

            {/* Zip Lock or Leak Proof Pouches */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap63.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="mb-4 saturate-50"
              />
              <p className="text-gray-700 font-medium">iii) Seal the box with
                BOPP tape</p>
            </div>
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap64.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="mb-4 saturate-50"
              />
              <p className="text-gray-700 font-medium">v) Place the sealed box
                in a LDPE polybag*</p>
            </div>
          </div>

        </div>

        <div>
          <p className='text-2xl font-bold mt-12'>Packaging Process For
            Liquid Items</p>
          <h1 className="text-xl font-bold mb-3 mt-6">1. Packaging Process: Preparing the item
          </h1>
          <div className="flex flex-wrap lg:space-x-20 justify-center gap-6">
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap66.png" // Replace with the actual image URL
                alt="Bubble Wrap"
                className=" h-64 mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium">Seal the bottle opening to
                avoid leakage. Use tapes
                and shrink films
              </p>
            </div>
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap67.png" // Replace with the actual image URL
                alt="Foam Sheets"
                className=" h-64 mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium">Pack the product in the
                leak proof polybag</p>
            </div>
          </div>

          <h1 className="text-xl font-bold mb-3 mt-12">2. Packaging Process: Packaging the item in the box
          </h1>
          <div className="flex flex-wrap lg:space-x-20 justify-center gap-6">
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap69.png" // Replace with the actual image URL
                alt="Bubble Wrap"
                className="mx-auto mb-3"
              />
            </div>
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap68.png" // Replace with the actual image URL
                alt="Foam Sheets"
                className="mx-auto mb-3"
              />
            </div>
            <p className='font-semibold text-center'>For liquid items in fragile containers, add extra layers of cushioning. Adopt the method discussed for fragile items to securely place the item in the box</p>
          </div>

        </div>

        <div>
          <p className='text-2xl font-bold mt-12'>Packaging Process For
            Books and Stationery</p>
          <h1 className="text-xl font-bold mb-3 mt-6">1. Packaging Process: Preparing the item
          </h1>
          <div className="flex flex-wrap lg:space-x-20 justify-center gap-6">
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap71.png" // Replace with the actual image URL
                alt="Bubble Wrap"
                className=" h-64 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium">Check the product condition
              </p>
            </div>
            <div className="text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap72.png" // Replace with the actual image URL
                alt="Foam Sheets"
                className=" h-64 object-cover mx-auto mb-3"
              />
              <p className="text-gray-700 font-medium">Wrap the product in the bubble wrap</p>
            </div>
          </div>

          <h1 className="text-xl font-bold mb-3 mt-12">2. Packaging Process: Packaging the item in the box
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Heat Shrink Sleeves */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap73.png"
                alt="Heat Shrink Sleeves"
                className="mb-4 saturate-50"
              />
              <p className="text-gray-700 font-medium">i) Choose a sturdy 3-ply
                corrugated box</p>
            </div>

            {/* Taping of Bottle Caps */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap74.png"
                alt="Taping Of Bottle Caps"
                className="mb-4 saturate-50"
              />
              <p className="text-gray-700 font-medium">ii) Wrap the item in the bubble wrap
                and place it in the corrugated box
                ensuring all voids are filled. Choose
                the appropriate size of the box</p>
            </div>

            {/* Zip Lock or Leak Proof Pouches */}
            <div className="flex flex-col items-center text-center">
              <img
                src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/cap76.png"
                alt="Zip Lock or Leak Proof Pouches"
                className="mb-4 saturate-50"
              />
              <p className="text-gray-700 font-medium">iii) Seal the box with BOPP
                tape</p>
            </div>
          </div>

        </div>

        <div>
          <h2 className="text-xl font-bold mb-6 text-gray-800">
            Final Checks
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {datatabel.map((section, index) => (
              <div
                key={index}
                className="bg-white border border-gray-300 rounded-lg shadow-md p-4"
              >
                <h3 className=" font-semibold text-gray-700 mb-4">
                  {section.title}
                </h3>
                <ul className="list-disc text-sm pl-6 space-y-2 text-gray-600">
                  {section.points.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div >
    </>
  )
}

export default Accodion


// import React, {  useRef, useState } from "react";
// import { RiArrowDropDownLine } from "react-icons/ri";
// import './Accodion.css';
// // import { ReactComponent as Images1 } from '../asset/img/p1.svg';

// import s2Image from '../asset/img/s2.png';
// import s1Image from '../asset/img/s1.png';
// import s33Image from '../asset/img/s33.png';
// import s4Image from '../asset/img/s4.png';
// import s66Image from '../asset/img/s66.png';
// import s9Image from '../asset/img/s9.png';
// import s88Image from '../asset/img/s88.png';
// import tableImage from '../asset/img/table.png';
// import p1Image from '../asset/img/p1.svg';

// const data = [
//   {
//     question: "Selection of Boxes",
//     features: [
//       {
//         name: 'Material',
//         description: '● Use corrugated boxes of 3 ply for products below 4Kg and not fragile',
//         description1: '● Use corrugated boxes of 5 ply for products above 4Kg and fragile',
//         description2: '● Use tamper evident boxes for high value items (Cost above Rs. 7000)',
//         description3: '● Ensure the material used can withstand the required edgecrush and burst factor loads',
//         description4: '● Optimize the size of the boxes as per the product dimensions',
//         description5: '● The box should not be too small or too big for the item shipped. An optimum size box should be chosen',
//         description6: '● Inspect the box for holes, tears, crushed edges and sturdiness. Avoid poor quality boxes for the safety of the item shipped',
//       },
//       {
//         name: 'Size', description: '● Optimize the size of the boxes as per the product dimensions',
//         description1: '● The box should not be too small or too big for the item shipped. An optimum size box should be chosen',
//       },
//       { name: 'Quick Check', description: '● Inspect the box for holes, tears, crushed edges and sturdiness. Avoid poor quality boxes for the safety of the item shipped' },
//     ],
//      images :[
//       { Images1:p1Image },
//   ]

//   },
//   {
//     question: "Selection of Flyers/Polybags",
//     description: "Flyers are quick and handy in packing of flexible items such as apparels or can be used as an added protection for the safety of the shipment from external fluids, tampering etc.",
//     features: [
//       {
//         name: 'Material',
//         description: '● Choose 60-80microns hotmelt glue adhesive LDPE polybags',
//         description1: '● Use tamper evident polybags for high value items (Cost above Rs.7000)',
//       },
//       { name: 'Quick Check', description: '● Inspect the polybag for any damages', description1: '● Ensure the opening is sealed properly after the packing of item' },
//     ],
//     images : [
//       { Images1: s1Image},
//   ]

//   },
//   {
//     question: "Packing of item",
//     description: "Packing an item involves leak proofing, cushioning, placing of the item and filling of the voids in the box. Enough cushioning needs to be provided to ensure no loads are transferred to the item.",
//     features: [
//       {
//         name: 'Material',
//         description: '● Bubble Wrap',
//         description1: '● Foam sheets',
//       },
//     ],
//     images: [
//       { Images1: s2Image },
//     ]

//   },
//   {
//     question: "Leaking Proofing",
//     description: "Liquid products need to be made leak proof before cushioning or packing. Common leak proofing techniques are mentioned below.",
//     features: [
//       {
//         name: 'Material',
//         description: '● Heat shrink sleeves',
//         description1: '● Taping of bottle caps',
//         description2: '● Zip lock or leak proof pouches',
//       },
//     ],
//     images: [
//       { Images1: s33Image },
//     ]

//   },
//   {
//     question: "Sealing of Shipment",
//     description: "Sealing ensures that the properly packed item is secured and intact inside the box throughout the journey of the shipment.",
//     features: [
//       {
//         name: 'Tape', description: '● Use Pressure Sensitive Tapes such as BOPP',
//       },
//       { name: 'Locations', description: '● Seal the center seam of the top and bottom of the box', description1: '● For heavy shipments, apply H-Taping by sealing both the center and edge seams on the box' },
//     ],
//     images: [
//       { Images1: s4Image },
//     ]
//   },
//   {
//     question: "Shipment labelling",
//     description: "Proper labeling is crucial for faster and safe handling of the shipment in reaching the intended destination.",
//     features: [
//       {
//         name: 'Essential data',
//         description: '● Barcode height (min. size : 8 mm)',
//         description1: '● Waybill number and Barcode (min. size : 8 MIL, 1MIL= 0.2032mm)',
//         description2: '● Order number and Barcode (min. size : 8 MIL, 1MIL= 0.2032mm)',
//         description3: '● Consignee address (min. font size: 8pts, Calibri body)',
//         description4: '● Return address (min. font size: 8pts, Calibri body)',
//         description5: '● Retail/Tax Invoice',
//       },
//       {
//         name: 'Location of Label', description: '● Paste the label on a seamless flat face of the box/flyer',
//         description1: '● Paste the label away from seams or edges of the box',
//         description2: '● Readability of barcode is important for faster and correct processing of shipments',
//         description3: '● In flyers/polybags, all the essential data on labels should be visible and the label should be placed flat',
//         description4: '● The pocket containing the label in flyer should be taped at the opening to avoid the loss of label',
//         description5: '● Thermal printed labels are strongly recommended over regular labels'
//       },
//     ],
//     images: [
//       { Images1: s66Image },
//     ],
//     imagess: [
//       { Images2: s9Image, name: 'What not to do' },
//     ]

//   },
//   {
//     question: "Special handling labels",
//     description: "Special handling labels helps in communicating the necessary information for appropriately handling the shipment.",
//     features: [
//       { name: 'Common categories', description: '● Fragile', description1: '● Perishables', description2: '● Dangerous goods', description3: '● Package orientation', description4: '● Keep dry' },
//     ],
//     images: [
//       { Images1: s88Image },

//     ]
//   },
//   // {
//   //   question: "Internal Packing material vs functionality",
//   //   description: "Internal Packing material vs functionality",
//   //   features: [
//   //   ],
//   //   images: [
//   //     { Images1: tableImage },
//   //   ]
//   // },
//   // {
//   //   question: "Product categories",
//   //   description: "Special handling labels helps in communicating the necessary information for appropriately handling the shipment.",
//   //   features: [
//   //     {
//   //       name: 'Electronic items',
//   //       description: '● Mobile phones & accessories',
//   //       description1: '● Tablets',
//   //       description2: '● Laptop & Computer accessories',
//   //     },
//   //     {
//   //       name: 'Electrical items', description: '● Small home appliances',
//   //       description1: '● Power equipment',
//   //       description2: '● Industrial equipment',
//   //     },
//   //     {
//   //       name: 'Fragile items',
//   //       description: '● Glassware',
//   //       description1: '● Crockery',
//   //       description2: '● Home decor',
//   //     },
//   //     {
//   //       name: 'Apparels',
//   //       description: '● Flexible packaging',
//   //       description1: '● Rigid packaging',
//   //     },
//   //     {
//   //       name: 'Fashion accessories',
//   //       description: '● Jewelry',
//   //       description1: '● Watches',
//   //     },
//   //     {
//   //       name: 'Liquid items',
//   //       description: '● Beauty & Personal Care',
//   //       description1: '● Food products, Medicines',
//   //       description2: '● Automotive',
//   //     },
//   //     {
//   //       name: 'Others',
//   //       description: '● Books & stationery',
//   //       description1: '● Travel gears',
//   //     },
//   //   ],
//   //   images: [
//   //   ]

//   // },
// ];

// const AccordionItem = ({ question, answer, isOpen, onClick, data }) => {
//   const contentHeight = useRef();
//   return (
//     <>
//       <div className="wrapper mb-7">
//         <button
//           className={`question-container ${isOpen ? "active" : ""}`}
//           onClick={onClick}
//         >
//           <p className="question-content
//         ">{question}</p>
//           <RiArrowDropDownLine className={`arrow ${isOpen ? "active" : ""}`} />
//         </button>

//         <div
//           ref={contentHeight}
//           className="answer-container"
//           // style={
//           //   isOpen
//           //     ? { height: contentHeight.current.scrollHeight }
//           //     : { height: "0px" }
//           // }
//         >
//           <div className="answer-content">
//             <div className="bg-white">
//               <div className="mx-auto grid max-w-auto grid-cols-1 items-center gap-x-8 gap-y-1 py-7  sm:px-6 sm:py-10 lg:max-w-auto lg:grid-cols-2 lg:px-8">
//                 <div>
//                   <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{data?.title}</h2>
//                   <p className="my-4 text-gray-500">
//                     {data?.description}
//                   </p>

//                   <dl className="space-y-10">
//                     {data?.features.map((feature) => (
//                       <div key={feature.name}>
//                         <dt className="font-medium mb-4 text-gray-900">{feature.name}</dt>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description}</dd>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description1}</dd>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description2}</dd>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description3}</dd>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description4}</dd>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description5}</dd>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description6}</dd>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description7}</dd>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description8}</dd>
//                         <dd className="mt-1 text-sm text-gray-500">{feature.description9}</dd>
//                       </div>
//                     ))}
//                   </dl>
//                 </div>
//                 <div className="">
//                   {
//                     data?.images?.map((image, index) => {
//                       return (
//                         <div key={ index}>
//                         <img
//                           src={image?.Images1}
//                           className="rounded-xl"
//                         />
//                         </div>

//                       )
//                     })
//                   }
//                 </div>
//               </div>
//               {
//                 data?.imagess?.map((image, index) => {
//                   return (
//                     <div key={ index}>
//                       <dt className="font-medium mb-4 text-gray-900">● {image.name}</dt>
//                       <img
//                         src={image?.Images2}
//                         className="rounded-xl"
//                       />
//                     </div>
//                   )
//                 })
//               }
//             </div>
//           </div>
//         </div>
//       </div>
//     </>

//   );
// };

// const Accordion = () => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const handleItemClick = (index) => {
//     setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
//   };

//   return (
//     <div className="mx-auto max-w-auto px-6 lg:px-8">
//       {data.map((item, index) => (
//         <AccordionItem
//           key={index}
//           question={item.question}
//           answer={item.answer}
//           isOpen={activeIndex === index}
//           onClick={() => handleItemClick(index)}
//           data={item}
//         />
//       ))}
//     </div>
//   );
// };

// export default Accordion;

